import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { DynamicsFieldsService } from 'src/app/shared/services';

@Injectable()
export class InformationCollectorByPaymentService {
    public formGroups = new BehaviorSubject<FormGroup[]>([]);
    private collectorForms = new BehaviorSubject<(FormGroup | null)[]>([]);

    constructor(private dynamicsFieldsService: DynamicsFieldsService) {}

    setFormGroups(formGroups: FormGroup[]): void {
        this.formGroups.next(formGroups);
    }

    getFormGroups(): Observable<FormGroup[]> {
        return this.formGroups.asObservable();
    }

    validateForms(): Observable<boolean> {
        return this.getFormGroups().pipe(
            map((formGroups) => {
                if (!formGroups?.length) {
                    return false;
                }
                return formGroups.every((formGroup) => {
                    return !!formGroup?.valid;
                });
            })
        );
    }

    get instant_formGroupsValidateForms(): boolean {
        return this.formGroups.value.every((form) => form.valid);
    }

    setCollectorForms(collectorForms: FormGroup | null, index: number): void {
        const newCollectorForms: (FormGroup | null)[] = this.collectorForms.value || [];
        newCollectorForms[index] = collectorForms;

        this.collectorForms.next(newCollectorForms);
    }

    getCollectorForms$(): Observable<(FormGroup | null)[]> {
        return this.collectorForms.asObservable();
    }

    get instant_collector_forms(): string {
        return this.dynamicsFieldsService.getCollectorFormValueByKey('customerRef');
    }

    markFormAsTouched(): Observable<string> {
        return this.getFormGroups().pipe(
            map((forms) => {
                forms?.forEach((form) => {
                    form.markAllAsTouched();
                });
                return 'Complete';
            })
        );
    }
}
